function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m48.238281 456.128906c-4.421875 0-8.039062-3.578125-8.039062-8 0-4.425781 3.535156-8 7.953125-8h.085937c4.417969 0 8 3.574219 8 8 0 4.421875-3.582031 8-8 8zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m488.015625 371.847656c-2.769531 0-5.457031-1.433594-6.925781-3.992187-2.21875-3.832031-.90625-8.71875 2.910156-10.925781 7.40625-4.28125 12-12.25 12-20.800782 0-13.234375-10.769531-24-24-24-4.425781 0-8-3.578125-8-8 0-4.425781 3.574219-8 8-8 22.054688 0 40 17.941406 40 40 0 14.230469-7.65625 27.511719-19.984375 34.640625-1.261719.734375-2.640625 1.078125-4 1.078125zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m272.007812 488.128906c-2.847656 0-5.609374-1.519531-7.054687-4.207031-2.097656-3.890625-.632813-8.746094 3.253906-10.832031l216-116.296875c3.871094-2.097657 8.746094-.632813 10.832031 3.253906 2.089844 3.890625.632813 8.746094-3.253906 10.832031l-216 116.296875c-1.199218.648438-2.496094.953125-3.777344.953125zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m272.007812 488.128906c-.34375 0-.6875-.023437-1.039062-.074218l-184-24c-4.382812-.566407-7.480469-4.582032-6.898438-8.957032.570313-4.386718 4.554688-7.523437 8.960938-6.898437l184 24c4.382812.570312 7.480469 4.585937 6.898438 8.960937-.523438 4.03125-3.960938 6.96875-7.921876 6.96875zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m88 480.128906h-80c-4.425781 0-8-3.578125-8-8v-216c0-4.425781 3.574219-8 8-8h80c4.425781 0 8 3.574219 8 8v216c0 4.421875-3.574219 8-8 8zm-72-16h64v-200h-64zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m311.992188 336.128906c-3.886719 0-7.296876-2.832031-7.894532-6.800781-.664062-4.367187 2.335938-8.449219 6.703125-9.113281l154.535157-23.527344c4.375-.664062 8.449218 2.335938 9.113281 6.703125.664062 4.371094-2.335938 8.449219-6.707031 9.113281l-154.542969 23.527344c-.398438.066406-.808594.097656-1.207031.097656zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m280 368.128906c-4.425781 0-8-3.578125-8-8 0-4.425781 3.574219-8 8-8 13.230469 0 24-10.769531 24-24 0-11.722656-8.351562-21.664062-19.863281-23.648437-4.351563-.753907-7.273438-4.886719-6.519531-9.242188.75-4.351562 4.902343-7.238281 9.238281-6.519531 19.207031 3.296875 33.144531 19.875 33.144531 39.410156 0 22.054688-17.945312 40-40 40zm0 0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m285.503906 304.59375c-.503906 0-1.023437-.050781-1.535156-.152344l-125.503906-24.472656c-4.335938-.839844-7.167969-5.046875-6.320313-9.382812.847657-4.339844 5.03125-7.171876 9.382813-6.320313l125.503906 24.46875c4.335938.839844 7.167969 5.050781 6.320312 9.386719-.742187 3.824218-4.09375 6.472656-7.847656 6.472656zm0 0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m160 280.128906h-72c-4.425781 0-8-3.578125-8-8 0-4.425781 3.574219-8 8-8h72c4.425781 0 8 3.574219 8 8 0 4.421875-3.574219 8-8 8zm0 0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m276.640625 367.9375c-.199219 0-.417969-.007812-.625-.027344l-100.632813-7.8125c-4.40625-.34375-7.703124-4.1875-7.359374-8.59375.34375-4.414062 4.214843-7.71875 8.59375-7.359375l100.628906 7.816407c4.410156.34375 7.707031 4.183593 7.363281 8.589843-.328125 4.203125-3.824219 7.386719-7.96875 7.386719zm0 0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m466.519531 312.574219c-3.832031 0-7.222656-2.765625-7.878906-6.679688-.730469-4.359375 2.207031-8.488281 6.566406-9.207031 2.234375-.375 4.511719-.558594 6.792969-.558594 4.425781 0 8 3.574219 8 8 0 4.421875-3.574219 8-8 8-1.414062 0-2.808594.117188-4.152344.34375-.441406.078125-.886718.101563-1.328125.101563zm0 0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m280 368.128906c-1.441406 0-2.855469-.082031-4.246094-.242187-4.394531-.496094-7.546875-4.460938-7.050781-8.839844.496094-4.390625 4.375-7.65625 8.839844-7.046875.816406.089844 1.625.136719 2.457031.136719 4.425781 0 8 3.574219 8 8 0 4.421875-3.574219 7.992187-8 7.992187zm0 0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m192.128906 286.113281c-.320312 0-.640625-.015625-.960937-.058593-4.390625-.527344-7.511719-4.511719-6.992188-8.894532 1.449219-12.023437 11.6875-21.097656 23.824219-21.097656 4.425781 0 8 3.578125 8 8 0 4.425781-3.574219 8-8 8-4.046875 0-7.464844 3.007812-7.9375 7-.496094 4.066406-3.941406 7.050781-7.933594 7.050781zm0 0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m368.007812 288.0625c-4.421874 0-8-3.574219-8-8 0-4.414062-3.582031-8-8-8-4.421874 0-8-3.574219-8-8 0-4.421875 3.578126-8 8-8 13.230469 0 24 10.769531 24 24 0 4.425781-3.574218 8-8 8zm0 0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m368.007812 328.175781c-4.421874 0-8-3.574219-8-8v-40.113281c0-4.421875 3.578126-8 8-8 4.425782 0 8 3.578125 8 8v40.113281c0 4.417969-3.574218 8-8 8zm0 0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m352.007812 272.0625h-144.007812c-4.425781 0-8-3.574219-8-8 0-4.421875 3.574219-8 8-8h144.007812c4.425782 0 8 3.578125 8 8 0 4.425781-3.574218 8-8 8zm0 0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m268.007812 272.046875c-4.421874 0-8-3.574219-8-8v-208.046875c0-4.425781 3.578126-8 8-8 4.425782 0 8 3.574219 8 8v208.046875c0 4.425781-3.574218 8-8 8zm0 0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m292 272.046875c-4.425781 0-8-3.574219-8-8v-208.046875c0-4.425781 3.574219-8 8-8s8 3.574219 8 8v208.046875c0 4.425781-3.574219 8-8 8zm0 0"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m292 28c-4.425781 0-8-3.574219-8-8 0-2.199219-1.800781-4-4-4s-4 1.800781-4 4c0 4.425781-3.574219 8-8 8s-8-3.574219-8-8c0-11.03125 8.96875-20 20-20s20 8.96875 20 20c0 4.425781-3.574219 8-8 8zm0 0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m396.128906 64c-4.425781 0-8-3.574219-8-8s3.574219-8 8-8c2.199219 0 4-1.800781 4-4s-1.800781-4-4-4c-4.425781 0-8-3.574219-8-8s3.574219-8 8-8c11.03125 0 20 8.96875 20 20s-8.96875 20-20 20zm0 0"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m164.105469 64c-11.035157 0-20-8.96875-20-20s8.964843-20 20-20c4.421875 0 8 3.574219 8 8s-3.578125 8-8 8c-2.203125 0-4 1.800781-4 4s1.796875 4 4 4c4.421875 0 8 3.574219 8 8s-3.585938 8-8 8zm0 0"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m396.128906 40.015625h-231.488281c-4.425781 0-8-3.574219-8-8 0-4.421875 3.574219-8 8-8h231.488281c4.421875 0 8 3.578125 8 8 0 4.425781-3.585937 8-8 8zm0 0"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m396.128906 64h-231.488281c-4.425781 0-8-3.574219-8-8s3.574219-8 8-8h231.488281c4.421875 0 8 3.574219 8 8s-3.585937 8-8 8zm0 0"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m268 40.015625c-4.425781 0-8-3.574219-8-8v-12.015625c0-4.425781 3.574219-8 8-8s8 3.574219 8 8v12.015625c0 4.425781-3.574219 8-8 8zm0 0"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m292 40c-4.425781 0-8-3.574219-8-8v-12c0-4.425781 3.574219-8 8-8s8 3.574219 8 8v12c0 4.425781-3.574219 8-8 8zm0 0"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m168.113281 216.046875c-26.472656 0-48.007812-21.527344-48.007812-48 0-4.421875 3.574219-8 8-8 4.421875 0 8 3.578125 8 8 0 17.648437 14.359375 32 32.007812 32 17.648438 0 32.007813-14.351563 32.007813-32 0-4.421875 3.574218-8 8-8 4.421875 0 8 3.578125 8 8 0 26.472656-21.546875 48-48.007813 48zm0 0"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m208.121094 176.046875h-80.015625c-4.425781 0-8-3.574219-8-8 0-4.421875 3.574219-8 8-8h80.015625c4.421875 0 8 3.578125 8 8 0 4.425781-3.585938 8-8 8zm0 0"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m128.105469 176.046875c-.890625 0-1.808594-.152344-2.691407-.472656-4.167968-1.484375-6.335937-6.0625-4.839843-10.214844l40.019531-112.046875c1.476562-4.167969 6.054688-6.367188 10.214844-4.839844 4.167968 1.488282 6.335937 6.0625 4.839844 10.214844l-40.015626 112.046875c-1.160156 3.273437-4.242187 5.3125-7.527343 5.3125zm0 0"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m208.121094 176.046875c-3.289063 0-6.367188-2.039063-7.527344-5.3125l-40-112.046875c-1.496094-4.160156.679688-8.734375 4.839844-10.214844 4.132812-1.511718 8.734375.679688 10.214844 4.839844l40 112.046875c1.496093 4.160156-.679688 8.738281-4.839844 10.214844-.886719.320312-1.800782.472656-2.6875.472656zm0 0"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m392.328125 224.175781c-26.535156 0-48.128906-21.582031-48.128906-48.128906 0-4.421875 3.578125-8 8-8 4.425781 0 8 3.578125 8 8 0 17.714844 14.417969 32.128906 32.128906 32.128906s32.128906-14.414062 32.128906-32.128906c0-4.421875 3.574219-8 8-8 4.421875 0 8 3.578125 8 8 0 26.539063-21.59375 48.128906-48.128906 48.128906zm0 0"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m432.335938 184.046875h-80.015626c-4.425781 0-8-3.574219-8-8 0-4.421875 3.574219-8 8-8h80.015626c4.425781 0 8 3.578125 8 8 0 4.425781-3.574219 8-8 8zm0 0"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m352.320312 184.046875c-.832031 0-1.6875-.136719-2.527343-.414063-4.183594-1.394531-6.457031-5.921874-5.058594-10.121093l40.019531-120.046875c1.398438-4.183594 5.878906-6.457032 10.117188-5.058594 4.183594 1.394531 6.457031 5.921875 5.058594 10.121094l-40.019532 120.046875c-1.117187 3.355469-4.238281 5.472656-7.589844 5.472656zm0 0"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "m432.335938 184.046875c-3.351563 0-6.472657-2.117187-7.582032-5.472656l-40-120.046875c-1.402344-4.191406.863282-8.726563 5.054688-10.121094 4.230468-1.398438 8.71875.867188 10.121094 5.058594l40 120.046875c1.398437 4.191406-.867188 8.726562-5.058594 10.121093-.847656.277344-1.703125.414063-2.535156.414063zm0 0"
});

var SvgIconCourt = function SvgIconCourt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -12 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCourt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-court.cc8dd58d.svg";
export { ForwardRef as ReactComponent };